<template>
  <div>
    <v-dialog v-model="dialogadd" max-width="650">
      <v-card>
        <v-card-title class="color-theme white--text">
          <h4 class="font-weight-light pl-3">Add / Edit Category</h4>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogadd = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pl-7 pr-5">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <warnningComponent
                v-bind:textInfo.sync="warning.textWarning"
                v-bind:typestatus.sync="warning.typeWarning"
                v-bind:alert.sync="warning.showWarnnig"
              ></warnningComponent>
              <v-row>
                <v-col cols="12">
                  <span class="body-2">Name</span>
                  <span class="error--text">*</span>
                  <v-text-field
                    class="text-field-border mr-3"
                    type="text"
                    placeholder="name"
                    v-model="item_catg.name"
                    required
                    hide-details="auto"
                    clearable
                    clear-icon="mdi-close mb-2"
                    solo
                    dense
                    flat
                    :rules="nameRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="mr-9">
                  <v-avatar
                    class="rounded-lg mt-4"
                    height="230"
                    width="200"
                    color="grey lighten-2"
                  >
                    <v-img :src="item_catg.logo" @load="loadingDialog = false"></v-img>
                  </v-avatar>
                </v-col>
                <v-col cols="7">
                  <span class="body-2">Logo</span>
                  <v-file-input
                    placeholder="choose logo"
                    class="text-field-border pl-2"
                    clearable
                    clear-icon="mdi-close mb-2"
                    solo
                    dense
                    flat
                    prepend-icon="mdi-camera"
                    @change="previewLogo"
                    @click:clear="cancelPreviewLogo"
                    v-model="logofile"
                    :rules="!item_catg.isEdit ? logoRules : logoEditRules"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-6 pr-8">
          <v-spacer></v-spacer>
          <v-btn
            width="100"
            outlined
            class="font-weight-regular button mx-1 text-capitalize"
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            width="100"
            color="rgb(66, 154, 216)"
            class="font-weight-regular button mx-1 text-capitalize"
            dark
            @click="saveCategory"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container class="mx-3">
      <v-row>
        <v-col cols="2" class="mr-5"> <h3>Category</h3> </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <span class="subtitle-2">Search</span>
          <v-text-field
            class="text-field-border subtitle-2"
            placeholder="search name"
            type="text"
            v-model="search_name"
            hide-details="auto"
            clearable
            clear-icon="mdi-close mb-2"
            solo
            dense
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <span class="search-status subtitle-2 mt-1">Status</span>
          <v-btn-toggle
            v-model="toggle_search_status"
            mandatory
            color="primary"
            @change="searchStatus"
          >
            <v-btn height="40" class="caption"> all </v-btn>
            <v-btn height="40" class="caption"> active </v-btn>
            <v-btn height="40" class="caption"> unactive </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="7" class="mt-5 text-right">
          <v-btn
            color="rgb(66, 154, 216)"
            class="ma-2 font-weight-regular"
            dark
            @click="openDialog"
            ><v-icon left> mdi-plus </v-icon>
            Add Category
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="item_catg_list"
        class="elevation-1 mr-3"
        :search="search_name"
        :page.sync="item_search.page"
        :items-per-page="item_search.limit"
        @page-count="item_search.page"
        hide-default-footer
      >
        <template v-slot:item.logo="{ item }">
          <div class="py-2">
            <v-img height="45" width="45" :src="item.logo" class="rounded-lg"></v-img>
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <span>{{ item.name }}</span>
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch
            v-model="item.status"
            inset
            @change="openConfirmDialog(item)"
          ></v-switch>
        </template>

        <template v-slot:item.createdate="{ item }">
          <span>{{ item.createdate | moment("DD/MM/YYYY HH:mm") }}</span>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            class="ma-2 body-2 primary--text text-capitalize"
            color="white"
            depressed
            @click="editDialog(item)"
          >
            Edit
          </v-btn>
          <!-- <v-btn
            class="ma-2 body-2 error--text text-capitalize"
            color="white"
            depressed
            @click="deleteData(item.id)"
          >
            Delete
          </v-btn> -->
        </template>
      </v-data-table>
      <v-row>
        <v-col>
          <v-pagination
            v-model="item_search.page"
            :length="maxpage"
            @input="getCategoryList"
          ></v-pagination>
        </v-col>
      </v-row>
      <completeDialog
        v-bind:cm_dialog.sync="completeWarning.isShow"
        v-bind:cm_title.sync="completeWarning.title"
        v-bind:cm_color.sync="completeWarning.colorBtn"
        v-bind:cm_text="completeWarning.text"
        @done="closeSuccesDialog"
      ></completeDialog>
      <confirmDialog
        v-bind:cf_dialog="confirmWarning.isShow"
        v-bind:cf_title="confirmWarning.title"
        v-bind:cf_color_btn1="confirmWarning.color_btn1"
        v-bind:cf_text="confirmWarning.text"
        @cancel="cancelActiveCategory"
        @active="activeCategory"
      ></confirmDialog>
      <!-- loading dialog -->
      <loadingDialog v-bind:ld_dialog.sync="loadingDialog"></loadingDialog>
    </v-container>
  </div>
</template>

<script>
import loadingDialog from "@/components/loadingDialog";
import warnningComponent from "@/components/warningAlert";
import completeDialog from "@/components/completeDialog";
import confirmDialog from "@/components/confirmDialog";
import { uploadImage } from "@/service/upload/upload";
import {
  fetchMarketCategory,
  insertMarketCategory,
  updateActiveMarketCategory,
  updateMarketCategory,
} from "@/service/category/category";
export default {
  name: "category",
  components: {
    warnningComponent,
    completeDialog,
    confirmDialog,
    loadingDialog,
  },
  data() {
    return {
      dialogadd: false,
      loadingDialog: false,
      valid: true,
      search_name: "",
      toggle_search_status: 0,
      name: "",
      nameRules: [(v) => !!v || "Name is required"],
      item_catg_list: [],
      maxpage: 1,
      item_search: {
        sort: "created_at",
        sortby: "-1",
        page: 1,
        limit: 10,
        active: null,
      },
      item_catg: {
        id: "",
        name: "",
        logo: "",
        isEdit: false,
        oldLogo: "",
      },
      item_edit: {
        id: "",
        status: "",
      },
      logofile: "",
      logoRules: [
        (v) => !v || v.size < 20000000 || "Logo size should be less than 2 MB!",
        (v) => !!v || "logo is required",
      ],
      logoEditRules: [
        (v) => !v || v.size < 20000000 || "Logo size should be less than 2 MB!",
      ],
      warning: {
        textWarning: "",
        typeWarning: "",
        showWarnnig: false,
      },
      completeWarning: {
        isShow: false,
        title: "Successfully Saved",
        text: "You are able to modify the status afterward.",
        colorBtn: "success",
      },
      confirmWarning: {
        isShow: false,
        title: "",
        text: "",
        color_btn1: "",
      },
    };
  },
  mounted() {
    this.getCategoryList();
  },
  computed: {
    headers() {
      return [
        {
          text: "Logo",
          sortable: false,
          value: "logo",
          filterable: false,
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
          filterable: false,
        },
        {
          text: "Create Date",
          value: "createdate",
          sortable: false,
          filterable: false,
        },
        {
          text: "Edit Category",
          value: "action",
          sortable: false,
          filterable: false,
          class: "pl-10",
        },
      ];
    },
  },
  methods: {
    closeDialog() {
      this.$refs.form.reset();
      this.dialogadd = false;
    },
    openDialog() {
      this.dialogadd = true;
      this.item_catg.logo = "";
      this.item_catg.isEdit = false;
    },
    editDialog(item) {
      this.dialogadd = true;
      this.item_catg.isEdit = true;
      this.item_catg.id = item.id;
      this.item_catg.name = item.name;
      this.item_catg.logo = item.logo;
      this.item_catg.oldLogo = item.logo;
    },
    searchStatus() {
      if (this.toggle_search_status == 1) {
        this.item_search.active = true;
      } else if (this.toggle_search_status == 2) {
        this.item_search.active = false;
      } else {
        this.item_search.active = null;
      }
      this.getCategoryList();
    },
    async previewLogo() {
      if (this.logofile.size < 20000000) {
        this.loadingDialog = true;
        //let blobUrl = URL.createObjectURL(this.logofile);
        let result = await uploadImage("market_category", this.logofile);
        this.item_catg.logo = result ? result : this.item_catg.logo;
      }
    },
    cancelPreviewLogo() {
      this.item_catg.logo = this.item_catg.oldLogo;
    },
    async getCategoryList() {
      this.item_catg_list = [];
      let result = await fetchMarketCategory(this.item_search);
      if (result.data) {
        result.data.forEach((item) => {
          this.item_catg_list.push({
            id: item._id,
            name: item.title,
            logo: item.image,
            status: item.active,
            createdate: item.created_at,
            categories: item.categories,
            levelSub: item.levelSub,
            priority: item.priority,
          });
        });
        this.maxpage = result.maxPage;
      }
    },
    async saveCategory() {
      if (this.$refs.form.validate()) {
        let msg = "";
        let msg_body = "";
        let type_msg = "success";

        if (this.item_catg.isEdit) {
          let category = this.item_catg_list.filter((catg) => {
            return catg.id == this.item_catg.id;
          });
          let params = category[0];
          params.name = this.item_catg.name;
          params.logo = this.item_catg.logo;
          let result = await updateMarketCategory(params);
          msg = "Update complete";
          msg_body = "The category have been successfully updated";
          type_msg = "success";
          if (result.message) {
            msg = "Can't Update";
            msg_body = result.message;
            type_msg = "error";
          }
        } else {
          let result = await insertMarketCategory(this.item_catg);
          msg = "Insert complete";
          msg_body = "The category have been successfully inserted";
          type_msg = "success";
          if (result.message) {
            msg = "Can't Insert";
            msg_body = result.message;
            type_msg = "error";
          }
        }
        await this.alertCompleteDialog(msg, msg_body, type_msg);
        await this.getCategoryList();
        await this.closeDialog();
      }
    },
    openConfirmDialog(item) {
      this.item_edit.id = item.id;
      this.item_edit.status = item.status;
      this.confirmWarning.isShow = true;
      //dialog text
      if (item.status) {
        this.confirmWarning.title = "Do you want to activate ?";
        this.confirmWarning.text =
          "The category will be activated when you click Confirm.";
        this.confirmWarning.color_btn1 = "success";
      } else {
        this.confirmWarning.title = "Do you want to suspend ?";
        this.confirmWarning.text =
          "Once the category is suspended, you are able to come back and modify the status afterward.";
        this.confirmWarning.color_btn1 = "error";
      }
    },
    cancelActiveCategory(value) {
      this.item_catg_list.forEach((item, idx) => {
        if (item.id == this.item_edit.id) {
          this.item_catg_list[idx].status = !this.item_edit.status;
        }
      });
      this.confirmWarning.isShow = value;
    },
    async activeCategory(value) {
      let category = this.item_catg_list.filter((catg) => {
        return catg.id == this.item_edit.id;
      });
      if (category.length == 1) {
        let result = await updateActiveMarketCategory(category[0]);
        let msg = "Successfully Saved";
        let msg_body = "You are able to modify the status afterward";
        let type_msg = "success";
        if (result.message) {
          msg = "Can't Saved";
          msg_body = result.message;
          type_msg = "error";
          this.cancelActiveCategory(false);
        }
        this.alertCompleteDialog(msg, msg_body, type_msg);
        this.item_edit.id = "";
        this.item_edit.status = "";

        if (this.toggle_search_status != 0) {
          this.searchStatus();
        }
      }
      this.confirmWarning.isShow = false;
    },
    closeSuccesDialog(value) {
      this.completeWarning.isShow = value;
    },
    alertWarning(text, type) {
      this.warning.showWarnnig = true;
      this.warning.textWarning = text;
      this.warning.typeWarning = type;
      setInterval(() => {
        this.warning.showWarnnig = false;
      }, 5000);
    },
    alertCompleteDialog(title, text, color = "success") {
      this.completeWarning.isShow = true;
      this.completeWarning.title = title;
      this.completeWarning.text = text;
      this.completeWarning.colorBtn = color;
    },
  },
};
</script>

<style scoped>
.color-theme {
  background-color: rgb(51, 97, 137);
}

.text-field-border {
  border: 1px solid;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}
.search-status {
  display: block;
}
</style>
